"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReclassifyProductsDialog = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const product_tree_node_search_1 = require("./product-tree-node-search");
const reclassify_products_dialog_styles_1 = require("./reclassify-products-dialog.styles");
const use_reclassify_hook_1 = require("../../../hooks/reclassify/use-reclassify.hook");
const hooks_1 = require("../../../client/hooks");
const components_1 = require("../../../components");
const generic_1 = require("../../../generic");
const localization_1 = require("../../../../localization");
const localization_utils_1 = require("../../../../localization/localization.utils");
const enrich_ai_1 = require("../../../../store/selectors/enrich-ai");
const ReclassifyProductsDialog = ({ productFilter, selectedStrategyNodeId, selectedItemsCount, expectedMatchedProductCount, onSuccess, onClose, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const [selectedNodeTitle, setSelectedNodeTitle] = (0, react_1.useState)(null);
    const selectedTreeNodePath = (0, enrich_ai_1.useSelectedTreeNodePath)();
    const { refetchCounters } = (0, hooks_1.useRefetchCounters)();
    const { reclassify, isLoading, error } = (0, use_reclassify_hook_1.useReclassify)({
        selectedTreeNodePath,
        selectedItemsCount,
        expectedMatchedProductCount,
    });
    const handleSubmit = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield reclassify({
                filter: productFilter,
                targetCategory: selectedNodeTitle,
            });
            refetchCounters({ selectedTreeNodeId: selectedStrategyNodeId });
            onSuccess();
        }
        catch (e) {
            // Errors are surfaced via hook state; dialog remains open for retry
            console.error(e);
        }
    });
    return (react_1.default.createElement(reclassify_products_dialog_styles_1.StyledDialog, { open: true, maxWidth: 'md', fullWidth: true, proceedButtonProps: {
            title: t({ key: 'APPLY' }),
            disabled: !selectedNodeTitle || isLoading,
            onClick: handleSubmit,
            endIcon: isLoading && react_1.default.createElement(generic_1.LoadingIndicator, null),
        }, cancelButtonProps: {
            title: t({ key: 'CANCEL' }),
            onClick: () => {
                onClose();
            },
        }, title: t({ key: 'PRODUCT_RECLASSIFY_TITLE' }) }, react_1.default.createElement(generic_1.ActionDialogContainer, null, react_1.default.createElement(generic_1.ActionDialogContent, null, selectedItemsCount && (react_1.default.createElement(ui_components_1.Typography, { className: 'product-count', variant: 'body2', color: 'textSecondary' }, t({
        key: 'PRODUCT_RECLASSIFY_TOTAL',
        values: { total: selectedItemsCount, highlight: localization_utils_1.renderBoldText },
    }))), error && react_1.default.createElement(components_1.Alert, { severity: "error" }, error), react_1.default.createElement(product_tree_node_search_1.ProductTreeNodeSearch, { selectedNodeTitle: selectedNodeTitle, onSelect: setSelectedNodeTitle })))));
};
exports.ReclassifyProductsDialog = ReclassifyProductsDialog;
